import {
  Activity,
  AlertTriangle,
  BatteryCharging,
  Cable,
  CircleCheck,
  CircleX,
  CircuitBoard,
  Cog,
  Fan,
  Gauge,
  Hexagon,
  LayoutPanelLeft,
  Lightbulb,
  type LucideIcon,
  Network,
  Plug,
  PlugZap,
  Radar,
  RefreshCw,
  Repeat,
  Router,
  ShieldCheck,
  Sparkles,
  ToggleLeft,
  Wrench,
  Zap,
} from "lucide-react";

/** أيقونات كهربائية/صناعية حسب التصنيف */
const BY_ICON: Record<string, LucideIcon> = {
  home: Lightbulb,
  "layout-panel-left": LayoutPanelLeft,
  cog: Fan,
  "toggle-left": ToggleLeft,
  cpu: CircuitBoard,
  gauge: Gauge,
  zap: Zap,
  repeat: RefreshCw,
  box: BatteryCharging,
  radar: Radar,
  cable: Cable,
  shield: ShieldCheck,
};

const BY_KEYWORD: [RegExp, LucideIcon][] = [
  [/محرك|موتور|motor/i, Fan],
  [/منزل|إنارة|اناره|مصباح/i, Lightbulb],
  [/سيطر|كونتكتر|contactor|ريلاي|relay/i, Wrench],
  [/لوح|panel|قاطع|breaker|mcb|mccb/i, LayoutPanelLeft],
  [/plc|برمج/i, CircuitBoard],
  [/vfd|inverter|انفرتر|درايف/i, Gauge],
  [/ats|تحويل تلقائي/i, Repeat],
  [/مولد|generator/i, BatteryCharging],
  [/محول|transformer/i, Hexagon],
  [/حساس|sensor/i, Radar],
  [/كابل|سلك|wire|cable/i, Cable],
  [/تأريض|ارضي|ground|earth/i, ShieldCheck],
  [/اتصال|شبك|communication|network/i, Network],
  [/بطاري|battery/i, BatteryCharging],
  [/قابس|فيش|plug/i, Plug],
  [/تغذي|فولتي|جهد|voltage/i, PlugZap],
  [/تيار|امبير|current/i, Activity],
];

export function categoryIcon(icon?: string | null, name?: string | null): LucideIcon {
  if (icon && BY_ICON[icon]) return BY_ICON[icon]!;
  const hay = `${name ?? ""} ${icon ?? ""}`;
  for (const [re, Ico] of BY_KEYWORD) if (re.test(hay)) return Ico;
  return Cog;
}

export function faultIcon(text: string): LucideIcon {
  for (const [re, Ico] of BY_KEYWORD) if (re.test(text)) return Ico;
  return Sparkles;
}

export { AlertTriangle, CircleCheck, CircleX, Router, Zap };
